export const addProtocolToUrl = (url) => {
  if (!url || url === '') return url;

  if (url.startsWith('http')) {
    return url;
  }

  return `https://${url}`;
};
